import { ColorsSchemeType } from '../colors'
import ThemedColors from './themes-list.json'

export type ThemedKeys =
	| 'ferry'
	| 'latter'
	| 'chubby'
	| 'burly'
	| 'calm'
	| 'soggy'
	| 'waggish'
	| 'foamy'
	| 'funny'
	| 'ultra'
	| 'flamer'
	| 'reflective'
	| 'futuristic'
	| 'silly'
	| 'divergent'
	| 'fancy'
	| 'nonstop'
	| 'region'
	| 'ocean'
	| 'dubrovka'

export const themedColors: Record<ThemedKeys, ColorsSchemeType> = ThemedColors

export type ThemeNames = keyof typeof themedColors
export type ThemeColors = typeof themedColors[keyof typeof themedColors]
